const useModals = () => {
  const isOpenAuthModal = ref(false);

  const setAuthModal = (state: boolean) => (isOpenAuthModal.value = state);

  return { isOpenAuthModal, setAuthModal };
};

export const modalStore = useModals();
